import {injectable} from "inversify";
import {CountryEnum} from "@/modules/base/enums";
import countries from '@/modules/team/resources/cities.json';
import {CityType} from "@/modules/team/types";
import chance from "@/modules/base/services/chance";

@injectable()
export default class CityRepository {
  public getCities(country: CountryEnum): CityType[] {
    return (countries as { [key in CountryEnum]?: [CityType] })[country] || [];
  }

  getOneByLevel(country: CountryEnum, level: number): CityType {
    const cities = this.getCities(country);
    const citiesChunk: CityType[] = collect(cities)
      .take(cities.length * Math.max(20, (100 - level)) / 100)
      .toArray();

    return chance.pickone<CityType>(citiesChunk);
  }
}
